export const getPlatformInfo = () => {
  return {
    language: navigator.language,
    platform: navigator.userAgentData ? navigator.userAgentData.platform : 'unknown',
    userAgent: navigator.userAgent
  };
};
